import { gql } from '@apollo/client';

export const callMeSupplementary = gql`mutation callMeSupplementary($input: CallMeInput!) {
  callMe(input: $input)
}
`
